import CloseIcon from "../../../assets/versionControl/close.svg?react";

import "./ScreeningReportModal.css";
import FeatureWorkOrderGroup from "../FeatureWorkOrders/FeatureWorkOrderGroup";
import { Dispatch, SetStateAction, useState } from "react";
import NfsButton from "../../genericComponents/NfsButton/NfsButton";
import { generateSkjermingsRapport } from "../../../utils/reportUtils";
import Modal from "react-modal";
import type Graphic from "@arcgis/core/Graphic";

interface ScreeningReportModalProps {
    isScreenReportModalOpen: boolean;
    closeModal: () => void;
    selectedFeature: Graphic;
    selectedWorkOrderIds: string[];
    setSelectedWorkOrderIds: Dispatch<SetStateAction<string[]>>;
}

const ScreeningReportModal = (props: ScreeningReportModalProps) => {

    const [isUploading, setIsUploading] = useState(false);

    return (
        <Modal
            isOpen={props.isScreenReportModalOpen}
            shouldCloseOnOverlayClick={true}
            shouldCloseOnEsc={true}
            onRequestClose={() => props.closeModal()}
            style={{
                overlay: {
                    background: 'rgba(37, 37, 37, 0.50)',
                },
                content: {
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    marginRight: '-50%',
                    transform: 'translate(-50%, -50%)',
                    padding: 0,
                    background: "none",
                    border: "none",
                },
            }}
        >
            <div className="screen-report-modal-container">
                <div className="screen-report-modal-header">
                    <h2>Skjermingsrapport</h2>
                    <button className="empty-button" onClick={props.closeModal}>
                        <CloseIcon />
                    </button>
                </div>
                <div className="screen-report-modal-content">
                    <span>Her kan du laste ned Skjermingsrapport for valgt lykt</span>
                    <br />
                    <span>Du kan også velge å laste den opp til valgt arbeidsordre</span>
                    <br />
                    <br />
                    <FeatureWorkOrderGroup
                        feature={props.selectedFeature}
                        selectable
                        selectedWorkOrderIds={props.selectedWorkOrderIds}
                        setSelectedWorkOrderIds={props.setSelectedWorkOrderIds}
                        workOrderClassFilter="DIR"
                        canHaveFdvWorkOrders={true}
                        canBeSentToFdv={false}
                        isEditing={false}
                    />
                    <div className="flex-row small-gap">
                        <NfsButton outlined onClick={() => generateSkjermingsRapport(props.selectedFeature, true, false)}>
                            Last ned rapporter
                        </NfsButton>
                        <NfsButton disabled={props.selectedWorkOrderIds.length === 0 || isUploading} onClick={async () => { setIsUploading(true); await generateSkjermingsRapport(props.selectedFeature, false, true, props.selectedWorkOrderIds); props.setSelectedWorkOrderIds([]); setIsUploading(false); }}>
                            Last opp til valgt arbeidsordre
                        </NfsButton>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default ScreeningReportModal;